import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import './LanguageToggle.css';

const LANGS = [
  { code: 'en', label: 'EN' },
  { code: 'fr', label: 'FR' },
];

const LanguageToggle = () => {
  const { lang, setLang } = useLanguage();

  return (
    <div className="lang-toggle" role="group" aria-label="Language">
      {LANGS.map(({ code, label }, i) => (
        <React.Fragment key={code}>
          {i > 0 && <span className="lang-sep" aria-hidden="true">/</span>}
          <button
            type="button"
            className={`lang-btn ${lang === code ? 'active' : ''}`}
            onClick={() => setLang(code)}
            aria-pressed={lang === code}
            data-testid={`lang-${code}`}
          >
            {label}
          </button>
        </React.Fragment>
      ))}
    </div>
  );
};

export default LanguageToggle;
